import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea, RadioGroup, Radio } from "@chakra-ui/react";
import 'services/Recruit/assets/css/bgVerification/style.css';
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import CustomDatePicker from "common/components/datePicker/CustomDatePicker";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { addRecruitmentProfile } from "common/redux/reducers/recruitmentSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { recruitConstant } from "services/Recruit/constant";
import { bgVerificationTabsData } from "services/Recruit/data/bgData";
import { natureOfEmplment } from "services/Recruit/data/bgData";
import { location } from "services/Recruit/data/bgData";
import { exitFormalitie } from "services/Recruit/data/bgData";
import { bgVerificationSchema } from "services/Recruit/schema/bgVerificationSchema";


const BgVerificationCreate = () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { users } = useSelector((state) => state.users);
    const [exitFormalities, setExitFormalities] = useState('');
    const [details, setDetails] = useState('');

    const handleRadioChange = (e) => {
        setExitFormalities(e.target.value);
        if (e.target.value === 'Yes') {
            setDetails('');
        }
    };
    const handleSubmit = (values) => {
        console.log(values);
    };
    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    const handleNext = () => {
        if (activeTabIndex < 3) {
            setActiveTabIndex(activeTabIndex + 1);
        }
    };

    const handleBack = () => {
        if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
        }
    }
    const handleBackToHome = () => {
      navigate("/recruit/bgVerification")
    }


    const handleFileChange = (dispatch, setFieldValue, fieldName) => (e) => {
        const file = e.target.files[0];
        if (file) {
            dispatch(uploadAttachment({ file, setFieldValue: (field, value) => setFieldValue(fieldName, value) }));
        }
    };

    useEffect(() => {
        dispatch(getDepartments());
        dispatch(fetchUserData());
    }, [dispatch]);

    return (
        <div className="pt-75">
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/campaign")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{recruitConstant.createBgVerification}</Text>
                        </Box>
                    </Box>

                    <Formik
                        initialValues={{
                            employeeID: "",
                            companyName: "",
                            location: "",
                            lastDesignation: "",
                            dateOfJoining: "",
                            department: "",
                            remunerationCTC: "",
                            reasonsForLeaving: "",
                            natureOfEmployment: "",
                            anyPerformanceIntegrity: "",
                            reason: "",
                            exitFormalitiesInput: "",
                            exitFormalitiesCompleted: "",
                            eligibleToReHire: "",
                            verifierDetails: "",
                            verifierName: "",
                            verifierDesignation: ""
                        }}
                        validationSchema={bgVerificationSchema}
                        onSubmit={(values, { resetForm }) => {
                            dispatch(addRecruitmentProfile({ values, resetForm, navigate }));
                        }}
                    >

                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {bgVerificationTabsData.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="employeeID">{recruitConstant.employeeID}<span className="astrick">*</span></FormLabel>
                                                        <Field name="employeeID">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterEmployeeID}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="companyName">{recruitConstant.companyName}<span className="astrick">*</span></FormLabel>
                                                        <Field name="companyName">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterCompanyName}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="location">{recruitConstant.location}<span className="astrick">*</span></FormLabel>
                                                        <Field name="location">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? recruitConstant.errorText : recruitConstant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.location}</option>
                                                                        {
                                                                            location.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>

                                                    </Box>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="lastDesignation">{recruitConstant.lastDesignation}<span className="astrick">*</span></FormLabel>
                                                        <Field name="lastDesignation">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterLastDesignation}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap="20px" w="100%">
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="dateOfJoining">{recruitConstant.dateOfJoining} <span className="astrick">*</span></FormLabel>
                                                        <Field name="dateOfJoining">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <CustomDatePicker
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color="red.500">{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="department">{recruitConstant.department}<span className="astrick">*</span></FormLabel>
                                                        <Field name="department">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterDepartment}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="remunerationCTC">{recruitConstant.remunerationCTC}<span className="astrick">*</span></FormLabel>
                                                        <Field name="remunerationCTC">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterremunerationCTC}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="reasonsForLeaving">{recruitConstant.reasonsForLeaving}<span className="astrick">*</span></FormLabel>
                                                        <Field name="reasonsForLeaving">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterReasonsForLeaving}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="natureOfEmployment">{recruitConstant.natureOfEmployment}<span className="astrick">*</span></FormLabel>
                                                        <Field name="natureOfEmployment">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? recruitConstant.errorText : recruitConstant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.pleaseSelect}</option>
                                                                        {
                                                                            natureOfEmplment.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="verifierName">{recruitConstant.verifierName}<span className="astrick">*</span></FormLabel>
                                                        <Field name="verifierName">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterVerifierName}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="verifierDesignation">{recruitConstant.verifierDesignation}<span className="astrick">*</span></FormLabel>
                                                        <Field name="verifierDesignation">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterVerifierDesignation}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="verifierDetails">{recruitConstant.verifierDetails}<span className="astrick">*</span></FormLabel>
                                                        <Field name="verifierDetails">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.enterVerifierDetails}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>

                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="exitFormalitiesCompleted">{recruitConstant.exitFormalitiesCompleted}<span className="astrick">*</span></FormLabel>
                                                        <Field name="exitFormalitiesCompleted">
                                                            {({ field, meta, form }) => (
                                                                <>
                                                                    <Stack direction="row" spacing={4}>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "Yes"}
                                                                            value="Yes"
                                                                            onChange={() => {
                                                                                form.setFieldValue("exitFormalitiesCompleted", "Yes");
                                                                                form.setFieldValue("exitFormalitiesCompletedInput", false); // Disable input and text when Yes is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.yes}
                                                                        </Radio>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "No"}
                                                                            value="No"
                                                                            onChange={() => {
                                                                                form.setFieldValue("exitFormalitiesCompleted", "No");
                                                                                form.setFieldValue("exitFormalitiesCompletedInput", true); // Enable input and text when No is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.no}
                                                                        </Radio>
                                                                    </Stack>

                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}

                                                                    {/* Conditionally disable the text and input field */}
                                                                    <Field name="reason">
                                                                        {({ field, meta }) => (
                                                                            <>
                                                                                <Text
                                                                                    className="common-padding"
                                                                                    color={form.values.exitFormalitiesCompletedInput ? "" : "gray"} // Change text color based on the condition
                                                                                    opacity={form.values.exitFormalitiesCompletedInput ? 1 : 0.5} // Lower opacity when disabled
                                                                                >
                                                                                    {recruitConstant.exitFormalitieText}
                                                                                </Text>

                                                                                <Input
                                                                                    {...field}
                                                                                    placeholder={recruitConstant.enterReason}
                                                                                    isDisabled={!form.values.exitFormalitiesCompletedInput} // Disable input when "No" is not selected
                                                                                />

                                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="eligibleToReHire">{recruitConstant.eligibleToReHire}<span className="astrick">*</span></FormLabel>
                                                        <Field name="eligibleToReHire">
                                                            {({ field, meta, form }) => (
                                                                <>
                                                                    <Stack direction="row" spacing={4}>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "Yes"}
                                                                            value="Yes"
                                                                            onChange={() => {
                                                                                form.setFieldValue("eligibleToReHire", "Yes");
                                                                                form.setFieldValue("showReasonInput", false); // Disable input and text when Yes is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.yes}
                                                                        </Radio>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "No"}
                                                                            value="No"
                                                                            onChange={() => {
                                                                                form.setFieldValue("eligibleToReHire", "No");
                                                                                form.setFieldValue("showReasonInput", true); // Enable input and text when No is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.no}
                                                                        </Radio>
                                                                    </Stack>

                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}

                                                                    {/* Conditionally disable the text and input field */}
                                                                    <Field name="reason">
                                                                        {({ field, meta }) => (
                                                                            <>
                                                                                <Text
                                                                                    className="common-padding"
                                                                                    color={form.values.showReasonInput ? "" : "gray"} // Change text color based on the condition
                                                                                    opacity={form.values.showReasonInput ? 1 : 0.5} // Lower opacity when disabled
                                                                                >
                                                                                    {recruitConstant.pleaseElaborate}
                                                                                </Text>

                                                                                <Input
                                                                                    {...field}
                                                                                    placeholder={recruitConstant.enterReason}
                                                                                    isDisabled={!form.values.showReasonInput} // Disable input when "No" is not selected
                                                                                />

                                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                </>
                                                            )}
                                                        </Field>

                                                    </Box>
                                                </Flex>
                                                <Flex>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="anyPerformanceIntegrity">{recruitConstant.anyPerformanceIntegrity}<span className="astrick">*</span></FormLabel>
                                                        <Field name="anyPerformanceIntegrity">
                                                            {({ field, meta, form }) => (
                                                                <>
                                                                    <Stack direction="row" spacing={4}>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "Yes"}
                                                                            value="Yes"
                                                                            onChange={() => {
                                                                                form.setFieldValue("anyPerformanceIntegrity", "Yes");
                                                                                form.setFieldValue("anyPerformanceInput", false); // Disable input and text when Yes is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.yes}
                                                                        </Radio>
                                                                        <Radio
                                                                            {...field}
                                                                            isChecked={field.value === "No"}
                                                                            value="No"
                                                                            onChange={() => {
                                                                                form.setFieldValue("anyPerformanceIntegrity", "No");
                                                                                form.setFieldValue("anyPerformanceInput", true); // Enable input and text when No is selected
                                                                            }}
                                                                        >
                                                                            {recruitConstant.no}
                                                                        </Radio>
                                                                    </Stack>

                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}

                                                                    {/* Conditionally disable the text and input field */}
                                                                    <Field name="reason">
                                                                        {({ field, meta }) => (
                                                                            <>
                                                                                <Text
                                                                                    className="common-padding"
                                                                                    color={form.values.anyPerformanceInput ? "" : "gray"} // Change text color based on the condition
                                                                                    opacity={form.values.anyPerformanceInput ? 1 : 0.5} // Lower opacity when disabled
                                                                                >
                                                                                    {recruitConstant.pleaseConfirmIf}
                                                                                </Text>

                                                                                <Input
                                                                                    {...field}
                                                                                    placeholder={recruitConstant.enterReason}
                                                                                    isDisabled={!form.values.anyPerformanceInput} // Disable input when "No" is not selected
                                                                                />

                                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                </>
                                                            )}

                                                        </Field>
                                                    </Box>
                                                </Flex>


                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn" variant="primary" onClick={handleBackToHome}>
                                                    {recruitConstant.back}
                                                </Button>
                                                <Button className="nextBtn" variant="primary" onClick={handleNext}>{recruitConstant.next}</Button>
                                            </Box>

                                        </TabPanel>
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">

                                                <Flex>
                                                    <Box w={'100%'}>
                                                        <FormLabel htmlFor="description">{recruitConstant.description} <span className="astrick">*</span></FormLabel>
                                                        <Field name="description">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <Textarea
                                                                        {...field}
                                                                        placeholder={recruitConstant.enterDescription}
                                                                        size="md"
                                                                        resize="vertical"
                                                                        minH="100px"
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color="red.500">{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn" variant="primary" onClick={handleBack}>
                                                    {recruitConstant.back}
                                                </Button>
                                                <Button
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                    onClick={() => navigate("/recruit/bgVerification")}

                                                >
                                                    {id ? recruitConstant.update : recruitConstant.save}
                                                </Button>

                                            </Box>

                                        </TabPanel>
                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </div>
    );
};

export default BgVerificationCreate;
